import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  importProvidersFrom,
  APP_INITIALIZER,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import {
  LucideAngularModule,
  LogOut,
  User,
  LayoutDashboard,
  Database,
  ClipboardList,
  Bot,
  Settings,
  ChevronRight,
  Menu,
  Lock,
  Activity,
  Sparkles,
  BrainCircuit,
  Shield,
  ArrowUpRight,
  Search,
  Plus,
  MoreHorizontal,
  Mail,
  Layers,
  Edit,
  Trash2,
  Filter,
  Upload,
  X,
  Users,
  UserCheck,
  UserPlus,
  Clock,
  Building2,
  Ban,
  CheckCircle,
  ChevronLeft,
  Check,
  XCircle,
  AlertTriangle,
  FileText,
  MessageCircle,
  Send,
  Save,
  ChevronDown,
  ArrowLeft,
  Eye,
  EyeOff,
  Funnel,
  SquarePen,
  CircleCheckBig,
  LoaderCircle,
  TvIcon,
} from 'lucide-angular';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { environment } from '../environments/environment.dev';
import { authInterceptor } from './core/auth/services/interceptor.service';

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.BASE_URL_API_KEYCLOAK,
      realm: '7care_teste',
      //realm: '7care_teste_seeds',
      clientId: 'portal-assistente-digital',
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    },
    providers: [
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [urlCondition],
      },
      AutoRefreshTokenService,
      UserActivityService,
    ],
  });

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /.*/,
  bearerPrefix: 'Bearer',
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloakAngular(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    importProvidersFrom(
      LucideAngularModule.pick({
        LogOut,
        User,
        LayoutDashboard,
        Database,
        ClipboardList,
        TvIcon,
        Bot,
        Settings,
        ChevronRight,
        Menu,
        Lock,
        Activity,
        Sparkles,
        BrainCircuit,
        Shield,
        ArrowUpRight,
        Search,
        Plus,
        MoreHorizontal,
        Mail,
        Layers,
        Edit,
        Trash2,
        Filter,
        Upload,
        X,
        Users,
        UserCheck,
        UserPlus,
        Clock,
        Building2,
        Ban,
        CheckCircle,
        ChevronLeft,
        Check,
        XCircle,
        AlertTriangle,
        FileText,
        MessageCircle,
        Send,
        Save,
        ChevronDown,
        ArrowLeft,
        Eye,
        EyeOff,
        Funnel,
        SquarePen,
        CircleCheckBig,
        LoaderCircle,
      }),
    ),
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor, authInterceptor])),
  ],
};
